<template>
  <div>
    <el-dialog
      :title="tit"
      :visible.sync="dialogVisible"
      width="60%"
      class="mbManage"
      top="5px"
      @opened="fuzhi"
      @closed="closed"
      custom-class="dialog"
      append-to-body
    >
      <div class="clearfix">
        <el-select
          v-model="value"
          @change="selectType"
          placeholder="请选择"
          size="mini"
          class="fl"
          style="width: 30%;"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <div class="fl" style="width: 10%;height: 2px;"></div>
        <el-input v-model="search" placeholder="快速查找" size="mini" class="fl" style="width: 30%;"></el-input>
        <div class="fl" style="width: 30%;text-align: center;">
          <el-button type="primary" round @click="createdTem" size="mini">创建模板</el-button>
        </div>
        <!-- <TaskSearch ref="TaskSearch"></TaskSearch> -->
      </div>
      <el-table :data="tables" style="width: 100%" tooltip-effect="dark">
        <el-table-column label="名称" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <i class="iconfont" :class="scope.row.ICON"></i>
            <span v-html="scope.row.NAME"></span>
          </template>
        </el-table-column>
        <el-table-column label="模板类型" width="120">
          <template slot-scope="scope">
            <span v-html="tempType(scope.row)"></span>
          </template>
        </el-table-column>
        <el-table-column label="检索条件" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.TEMPTYPE == 0">
              <span
                v-for="(item,index) in queryTitle(scope.row.CONTENT)"
                :key="item.title"
              >{{item.title}}:{{item.value}}</span>
            </div>
            <!-- <div v-else>
							<span v-for="(item,index) in scope.row.nameArr" :key="item.ID">{{item}}</span>
            </div>-->
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="170">
          <template slot-scope="scope">
            <el-tooltip content="编辑" placement="top">
              <el-button
                type="text"
                :disabled="scope.row.ROLETYPE == 2 && userId !=='super' ? true : false"
                size="small"
                @click="redact(scope.row)"
              >编辑</el-button>
            </el-tooltip>
            <el-tooltip content="删除" placement="top">
              <el-button
                type="text"
                :disabled="scope.row.ROLETYPE == 2 && userId !=='super' ? true : false"
                size="small"
                class="el-icon-delete"
                @click.native.prevent="deleteRow(scope.$index, tables)"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="添加到模板" placement="top">
              <el-button
                type="text"
                :disabled="scope.row.VISIBLE"
                size="small"
                class="el-icon-plus"
                @click="addToHome(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="移除" placement="top">
              <el-button
                type="text"
                :disabled="!scope.row.VISIBLE"
                size="small"
                class="el-icon-remove"
                @click.native.prevent="removeRow(scope.$index, tables)"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="执行" placement="top">
              <el-button
                type="text"
                size="small"
                class="iconfont icon-zhihang"
                @click.native.prevent="implement(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="选择分组" :visible.sync="selectfa" width="30%" append-to-body>
        <div>
          <el-tag
            v-for="(item,index) in temClass"
            :key="item.ID"
            @click.native="selectClass(item,index)"
            size="medium"
            :hit="index == isHit ? true : false"
            :type="item.TEMPTYPE == 4 ? 'success' : 'info'"
          >{{ item.NAME }}</el-tag>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="selectfa = false">取 消</el-button>
          <el-button type="primary" @click="selectfaAdd">确 定</el-button>
        </span>
      </el-dialog>
      <resultAmend ref="resultAmend"></resultAmend>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  SaveTemplateVisble,
  GetTaskListByTaskIdList,
  DelTemplate,
  GetAllTemplateByUserId
} from "@/api/modules/basicData/task";
// import TaskSearch from '../components/TaskSearch'
import resultAmend from "./resultAmend";
export default {
  props: {
    tit: String
  },
  data() {
    return {
      dialogVisible: false,
      options: [
        {
          value: 0,
          label: "所有"
        },
        {
          value: 1,
          label: "系统搜索模板"
        },
        {
          value: 2,
          label: "自定义搜索模板"
        },
        {
          value: 3,
          label: "结果集模板"
        }
      ],
      value: 0,
      dormitory: [],
      search: "",
      isHit: null, // 当前选中的一个分组index
      temClassObj: "",
      selectfa: false,
      waitTemp: {},
      temporary: [],
      newTemType: 0
    };
  },
  watch: {},
  computed: {
    tables() {
      // table的模糊查找
      const search = this.search;
      let arr = [];
      if (search) {
        this.dormitory.forEach(c => {
          if (c.NAME.toLowerCase().indexOf(search) > -1) {
            arr.push(c);
          }
        });
        return arr;
      }
      return this.dormitory;
    },
    userId: function() {
      return this.$store.state.task.userId;
    },
    temClass: function() {
      return this.$store.state.template.temClass;
    }
  },
  components: {
    // TaskSearch,
    resultAmend
  },
  mounted() {},
  methods: {
    selectType(val) {
      this.newTemType = val;
      this.dormitory = [];
      if (val == 0) {
        this.dormitory = this.temporary;
      } else if (val == 1) {
        this.temporary.forEach(c => {
          if (c.ROLETYPE == 2) {
            this.dormitory.push(c);
          }
        });
      } else if (val == 2) {
        this.temporary.forEach(c => {
          if (c.TEMPTYPE == 0 && c.ROLETYPE != 2) {
            this.dormitory.push(c);
          }
        });
      } else {
        this.temporary.forEach(c => {
          if (c.TEMPTYPE == 1 && c.ROLETYPE != 2) {
            this.dormitory.push(c);
          }
        });
      }
    },
    fuzhi() {
      this.dormitory = this.temporary;
    },
    closed() {
      this.newTemType = 0;
      this.value = 0;
    },
    tempType(val) {
      if (val.TEMPTYPE == 0) {
        if (val.ROLETYPE == 0) {
          return "自定义搜索模板";
        } else if (val.ROLETYPE == 2) {
          return "系统搜索模板";
        }
      } else {
        return "结果集模板";
      }
    },
    addToHome(val) {
      this.selectfa = true;
      this.waitTemp = val;
    },
    implement(row){
      this.dialogVisible=false;
      this.$emit("getAllTask", row);
    },
    deleteRow(index, rows) {
      this.$confirm("此操作将永久删除该模板, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          DelTemplate(rows[index].ID, this.userId, 5, "").then(res => {
            if (res == 1) {
              rows.splice(index, 1);
              this.$store.commit("getAllTemplate");
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    removeRow(index, rows) {
      let type = rows[index].ROLETYPE === 2 ? 6 : 3;
      DelTemplate(rows[index].ID, this.userId, type, "").then(res => {
        if (res == 1) {
          this.tables.forEach(c => {
            if (c.ID == rows[index].ID) {
              c.VISIBLE = false;
            }
          });
          this.$store.commit("getAllTemplate");
          this.$message({
            type: "success",
            message: "移除成功!"
          });
        }
      });
    },
    createdTem() {
      this.$emit("mbSearch", 0);
    },
    redact(val) {
      // 编辑
      console.log(val, "编辑");
      // this.$root.$emit('nowTemplate', val);
      this.$store.state.template.tagItem = val;
      // this.$root.$emit('amendSearch', val);
      this.$store.commit("redactTemplate", val);
      if (val.TEMPTYPE == 1) {
        this.$refs.resultAmend.dialogVisible = true;
      } else {
        this.$emit("mbSearch", 1);
      }
    },
    selectClass(val, index) {
      this.temClassObj = val;
      this.isHit = index;
    },
    selectfaAdd() {
      console.log(this.waitTemp, "this.waitTemp");
      console.log(this.temClassObj, "this.temClassObj");
      // if (this.waitTemp.ROLETYPE === 2) {
      //   if (this.temClassObj.TEMPTYPE !== 4) {
      //     this.$message({
      //       message: "此为系统模板,请选中系统分组！",
      //       type: "warning"
      //     });
      //     return false;
      //   }
      // }
      let arr = [...this.temporary];
      arr.forEach(c => {
        if (c.ID == this.waitTemp.ID) {
          c.VISIBLE = true;
          c.PID = this.temClassObj.ID;
        }
      });
      SaveTemplateVisble(arr, this.userId).then(res => {
        if (res == 1) {
          // this.$root.$emit('refreshLeft',true);
          this.$store.commit("getAllTemplate");
          this.selectfa = false;
        }
      });
    },
    queryTitle(CONTENT) {
       try {
        let queryTitle = JSON.parse(CONTENT);
        return queryTitle ? queryTitle.queryTitle : [];
        console.log("Title", queryTitle);
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
<style scoped>
.dialog >>> .el-dialog__header {
  padding: 5px 20px;
  border-bottom: 1px solid #d9d9d9;
  background-color: #f0f4fa;
  line-height: 1;
}

.dialog >>> .el-dialog__body {
  padding: 10px 20px 30px 20px;
}

.dialog >>> .el-dialog__headerbtn {
  top: 11px;
}

.mbManage >>> .el-dialog__body {
  padding: 10px 20px;
}
.mbManage {
  /* z-index: 2332 !important; */
}

.templateIcon {
  margin-right: 5px;
  margin-bottom: 5px;
}

.templateIcon:hover {
  color: #409eff !important;
}

.selectIcon {
  margin-top: 20px;
}

#rClick {
  position: fixed;
  top: 0;
  left: 0;
}

/*
	.searchSel .searchIpt{
		width: 40%;
	} */
</style>
